import React from 'react';
import { Form } from 'react-bootstrap';

interface RequiredLabelProps {
    htmlFor?: string;
    className?: string;
    children: React.ReactNode;
}

const RequiredLabel: React.FC<RequiredLabelProps> = ({ htmlFor, className, children }) => (
    <Form.Label htmlFor={htmlFor} className={className}>
        {children} {<span className="text-danger">*</span>}
    </Form.Label>
);

export default RequiredLabel;